import axios from "axios";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

export const fetchFeedback = async (params) => {
  const callResponse = await axios({
    url: endpoints.feedbackBase,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const createFeedback = async (data) => {
  const callResponse = await axios({
    url: endpoints.feedbackBase,
    method: "post",
    headers: getHeaders(),
    data,
  })
  
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

// export const deleteFeedbackType = async (data) => {
//   const callResponse = await axios({
//     url: endpoints.employeeType,
//     method: "delete",
//     headers: getHeaders(),
//     data,
//   })
//     .then((response) => response.data)
//     .catch((err) => ({status:0,response:err.response,code:err.response.status}));

//   return callResponse;
// };

export const updateFeedback = async (data) => {
  const callResponse = await axios({
    url: endpoints.feedbackBase,
    method: "patch",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};
